import type { Plan } from "@circle-react/types";
import type { IconName } from "@circleco/compass/components/Icon";

import { t } from "@/i18n-js/instance";
import {
  isCurrent,
  isRedeemingOffer,
  shouldContactSupport,
} from "@/react/helpers/plansHelpers";

import {
  type ButtonVariant,
  getButtonTranslationKey,
  getButtonVariant,
} from "./submitHelpers";

export interface ButtonConfig {
  className: string;
  disabled: boolean;
  shouldShowContactSupport: boolean;
  startIcon?: IconName;
  testId: string;
  text: string;
  variant: ButtonVariant;
}

export const useButtonConfig = (plan: Plan): ButtonConfig => {
  const shouldShowContactSupport = shouldContactSupport(plan.plan_action);
  if (shouldShowContactSupport) {
    return {
      disabled: false,
      shouldShowContactSupport: true,
      testId: `submit-button-${plan.plan_action}`,
      text: t("pricing_plans.actions.contact_cx"),
      variant: "secondary",
      className: "",
    };
  }
  const isOfferHighlighted = !!plan.is_on_offer && !isCurrent(plan.plan_action);
  const variant = isOfferHighlighted
    ? "marketing-gradient"
    : getButtonVariant(plan);
  const discountPercentage = plan.plan_coupon?.display_discount_percentage;
  const text =
    isRedeemingOffer(plan.plan_action) && discountPercentage
      ? t("pricing_plans.actions.redeem_offer_with_discount", {
          discount_percentage: discountPercentage,
        })
      : t(getButtonTranslationKey(plan), {
          plan_name: plan.display_name,
        });

  return {
    disabled: isCurrent(plan.plan_action),
    shouldShowContactSupport: false,
    startIcon: isOfferHighlighted ? "gift" : undefined,
    testId: `submit-button-${plan.plan_action}`,
    text,
    className: "",
    variant: variant || "secondary",
  };
};
